<template>
    <div class="content-box">
        <div>
            <router-link :to="{ name: 'af-auditoria-af' }" style="color: blueviolet; float: left;">
                <i class="fa fa-arrow-left"></i>
                Regresar
            </router-link>
            <div class="btn-group" style="float: right;">
                <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Acciones &nbsp;<i class="fas fa-cogs"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item" type="button" :disabled="current.estado != 'A'"><i
                            class="fas fa-clipboard-check"></i> &nbsp;Finalizar Aud.
                    </button>
                    <button class="dropdown-item" type="button" :disabled="current.estado != 'B'"><i
                            class="fas fa-trash-alt"></i> &nbsp;Anular Aud.</button>
                </div>
            </div>
        </div>
        <br><br><br>
        <div class="element-wrapper">
            <div class="element-box">
                <div class="col-12" style="text-align: center;">
                    <h5 class="form-header">Auditoría #{{ current.numero }}
                        <br>
                        <span class="badge" :class="{
                            'badge badge-pill badge-success': current.estado === 'A',
                            'badge badge-pill badge-dark': current.estado === 'B',
                            'badge badge-pill badge-danger': current.estado === '9'
                        }">
                            {{ getEstadoLabel(current.estado) }}
                        </span>
                    </h5>
                </div>
                <br>
                <div class="controls-above-table">
                    <div class="row col-12">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label>Tienda</label>
                                <br>
                                <input type="text" class="form-control form-control-sm w-100"
                                    :value="current.tienda_obj ? current.tienda_obj.nombre : '-'" disabled>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label>Categoría Auditada</label>
                                <br>
                                <input type="text" class="form-control form-control-sm w-100"
                                    :value="current.grupo_obj ? current.grupo_obj.nombre : 'Todas las Categorías'"
                                    disabled>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" v-if="isMobile" style="text-align: left;">
                            <button @click="toggleDates" class="btn btn-link" style="color: gray; font-size: 12px;">
                                <i :class="isDatesVisible ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                {{ isDatesVisible ? 'Ocultar' : 'Mostrar más' }}
                            </button>
                        </div>
                    </div>
                    <div class="row col-12" v-show="isDatesVisible || !isMobile">
                        <div class="col-12 col-sm-4">
                            <div class="form-group">
                                <label>Usuario</label>
                                <br>
                                <input type="text" class="form-control form-control-sm w-100"
                                    :value="current.usuario_obj ? current.usuario_obj.username : ' - '" disabled>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <div class="form-group">
                                <label>Fecha Inicio</label>
                                <br>
                                <input type="text" class="form-control form-control-sm w-100"
                                    :value="formatDate(current.fecha_creacion)" disabled>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <div class="form-group">
                                <label>Fecha Finalización</label>
                                <br>
                                <input type="text" class="form-control form-control-sm w-100"
                                    :value="formatDate(current.fecha_finalizacion)" disabled>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12">
                        <button class="btn-block btn btn-primary" data-toggle="modal" data-target="#exampleModalLong"
                            v-if="current.estado == 'A'">Nuevo Registro <i class="fas fa-plus"></i></button>
                    </div>
                </div>
            </div>
            <div class="element-wrapper">
                <div class="element-box">
                    <div class="form-header">
                        <h6 style="font-size: 14px;">Lista de Activos Encontrados:</h6>
                    </div>
                    <div class="form-body">
                        <table class="table table-hover">
                            <thead>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Modal Buscar Producto -->
            <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" style="background-color: rgba(0, 0, 0, 0.05);">
                            <h5 class="modal-title" id="exampleModalLongTitle">Buscar Activo Fijo &nbsp;<i
                                    class="fas fa-couch"></i></h5>
                            <button type="button" class="btn btn-danger" @click="cancelar()"><i
                                    class="fas fa-times"></i></button>
                        </div>
                        <div class="modal-body">
                            <label>Barra GS1</label>
                            <input class="form-control" type="text" v-model="currentDetalle.barra_gs1"
                                @keyup.enter="setSelectedActivo"
                                :disabled="currentDetalle.activof_set && Object.keys(currentDetalle.activof_set).length > 0">
                        </div>
                        <div class="col-12"
                            v-if="currentDetalle.activof_set && Object.keys(currentDetalle.activof_set).length > 0">
                            <div class="col-12">
                                <h6 style="color: #406b27; font-size: 16px;">
                                    ¡Activo Fijo Encontrado! <i class="fas fa-check-circle"></i></h6>
                                <small style="color: #888; font-size: 12px;">ID: {{
                                    currentDetalle.activof_set.identificador }}</small>
                                <hr color="#568e33">
                                <div>
                                    <label>Nombre</label>
                                    <input class="form-control" type="text" v-model="currentDetalle.activof_set.nombre"
                                        :disabled="true">
                                </div>
                                <div>
                                    <label>Tienda</label>
                                    <input class="form-control" type="text"
                                        v-model="currentDetalle.activof_set.tienda_obj.nombre" :disabled="true">
                                </div>
                                <div>
                                    <label>Categoría</label>
                                    <input class="form-control" type="text"
                                        v-model="currentDetalle.activof_set.grupo_obj.nombre" :disabled="true">
                                </div>
                                <div>
                                    <label>Marca</label>
                                    <input class="form-control" type="text"
                                        v-model="currentDetalle.activof_set.marca_obj.nombre" :disabled="true">
                                </div>
                                <div>
                                    <label>Estado</label>
                                    <input class="form-control" type="text"
                                        v-model="estadoTexto[currentDetalle.activof_set.estado]" :disabled="true">
                                </div>
                                <div>
                                    <label>Descripción</label>
                                    <textarea class="form-control" type="text"
                                        v-model="currentDetalle.activof_set.descripcion" :disabled="true"></textarea>
                                </div>
                                <hr color="#568e33">
                                <div style="height:auto; width: auto; background-color: #efefef; cursor: pointer;">
                                    <img v-if="currentDetalle.activof_set.imagen" class="decor"
                                        style="max-width: 100%; max-height: 200px; object-fit: contain;"
                                        :src="currentDetalle.activof_set.imagen"
                                        @click="openImageInFullscreen(currentDetalle.activof_set.imagen)" />
                                    <span v-else
                                        style="display: block; text-align: center; color: #888; font-size: 14px;">
                                        No hay imagen disponible. &nbsp;<i class="fas fa-camera"></i>
                                    </span>
                                </div>
                            </div>
                            <hr color="#568e33">
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary w-100" @click="setSelectedActivo"
                                v-if="!currentDetalle.activof_set || Object.keys(currentDetalle.activof_set).length === 0">
                                <i class="fas fa-search"></i>
                            </button>
                            <br>
                            <div class="btn-group w-100" role="group" aria-label="Basic example"
                                v-if="currentDetalle.activof_set && Object.keys(currentDetalle.activof_set).length > 0">
                                <button type="button" class="btn btn-primary w-50">Añadir &nbsp;<i
                                        class="fas fa-check"></i></button>
                                <button type="button" class="btn btn-secondary w-50" @click="limpiarCurrent()">
                                    Buscar Otro &nbsp;<i class="fas fa-undo"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import AfActivoService from '../../../services/af/AfActivoService';

export default {

    data() {
        return {
            current: {},
            isDatesVisible: false,
            isMobile: false, // Estado para identificar si es handheld, dará opción a comprimir algunos input :)
            currentDetalle: {
                barra_gs1: "",
                activo: "",
                activof_set: [],
            },
            activo: {
                activo_obj: "",
            },
            estadoTexto: {
                'E': 'Excelente',
                'B': 'Buen Estado',
                'M': 'Mal Estado',
                '9': 'De Baja'
            },

        };
    },
    mounted() {
        this.isMobile = this.checkIfMobile();
        this.refreshData();
        window.addEventListener('resize', this.updateMobileStatus);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateMobileStatus);
    },
    methods: {
        refreshData() {
            let self = this;
            DynamicService.getById(
                "af",
                "auditoria-af",
                this.$route.params.id
            ).then((response) => {
                self.current = response.data;
            });
        },
        formatDate(dateString) {
            if (!dateString) {
                return 'En Proceso';
            }
            return moment(dateString).format('DD-MM-YYYY HH:mm') + " Hrs.";
        },
        toggleDates() {
            let self = this;
            self.isDatesVisible = !self.isDatesVisible; // Para cambiar la visibilidad de los input de fechas si es Handheld
        },
        checkIfMobile() {
            return window.innerWidth <= 576;
        },
        updateMobileStatus() {
            this.isMobile = this.checkIfMobile();
            if (!this.isMobile) {
                this.isDatesVisible = true;
            }
        },
        getEstadoLabel(estado) {
            switch (estado) {
                case 'A':
                    return 'Abierta';
                case 'B':
                    return 'Finalizada';
                case '9':
                    return 'Anulada';
                default:
                    return 'Desconocido';
            }
        },
        setSelectedActivo() {
            if (this.currentDetalle.barra_gs1) {
                DynamicService.fetch("af", "activo", {
                    barra_gs1: this.currentDetalle.barra_gs1,
                }).then((response) => {
                    if (response.data && response.data.results && response.data.results.length > 0) {
                        this.activo = response.data.results[0];
                        if (this.activo) {
                            this.currentDetalle.activof_set = this.activo;
                        } else {
                            Notifications.alert.error(
                                "Error",
                                "No se pudo encontrar el activo fijo correspondiente a esa barra."
                            );
                        }
                    } else {
                        Notifications.alert.error(
                            "Error",
                            "No se encontró ningún activo fijo con ese código de barra."
                        );
                    }
                }).catch((error) => {
                    Notifications.alert.error(
                        "Error",
                        "Hubo un problema al obtener el activo fijo."
                    );
                });
            } else {
                Notifications.alert.error(
                    "Error",
                    "Por favor ingrese un código de barra válido."
                );
            }
        },
        limpiarCurrent() {
            let self = this;
            self.currentDetalle = {
                barra_gs1: "",
                activo: "",
                activof_set: [],
            };
        },
        cancelar() {
            let self = this;
            self.limpiarCurrent();
            $("#exampleModalLong").modal("hide");
        },
        openImageInFullscreen(imageUrl) {
            const modal = document.createElement('div');
            modal.style.position = 'fixed';
            modal.style.top = '0';
            modal.style.left = '0';
            modal.style.width = '100%';
            modal.style.height = '100%';
            modal.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
            modal.style.display = 'flex';
            modal.style.alignItems = 'center';
            modal.style.justifyContent = 'center';
            modal.style.zIndex = '9999';

            const img = document.createElement('img');
            img.src = imageUrl;
            img.style.maxWidth = '90%';
            img.style.maxHeight = '90%';
            img.style.objectFit = 'contain';

            const closeButton = document.createElement('div');
            closeButton.innerHTML = 'X';
            closeButton.style.position = 'absolute';
            closeButton.style.top = '10px';
            closeButton.style.right = '10px';
            closeButton.style.fontSize = '30px';
            closeButton.style.color = 'white';
            closeButton.style.cursor = 'pointer';
            closeButton.style.zIndex = '10000';

            const closeModal = () => {
                document.body.removeChild(modal);
            };

            modal.onclick = (event) => {
                if (event.target === modal) {
                    closeModal();
                }
            };

            closeButton.onclick = closeModal;

            modal.appendChild(img);
            modal.appendChild(closeButton);
            document.body.appendChild(modal);
        },
    }

}
</script>
<style scoped>
@media (min-width: 577px) {
    .date-fields {
        display: block;
    }
}

@media (max-width: 576px) {
    .date-fields {
        display: none;
    }
}

img.decor {
    object-fit: cover;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.close-modal-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 30px;
    color: white;
    cursor: pointer;
    z-index: 10000;
}
</style>